import uniqid from 'uniqid';
import { toastr } from 'react-redux-toastr';
import { dispatch } from '@rematch/core';
import { push } from "react-router-redux";

import {
    registerAccountUserService,
    accountUsersService,
    generateOtpService,
    checkUserService,
    accountService,
    resetPasswordService,
    verifyEmailService
} from '../../services/feathers.service';

const initialState = {
    registered: false,
    emailId: null,
    firstName: null,
    lastName: null,
    registrationError: null,
    accountData: {},
    accountLogoObjectCloudinary: {},
    userForVerification:null,
    verifyUserError:false,
    emailVerificationStatus: null,
    loaderBar: false,
    setAccountName: null,
};

export default {
    state: initialState,
    reducers: {
        setError(state, payload) {
            return {
                ...state,
                registrationError: payload,
            }
        },
        endRegistration(state, payload) {
            return {
                ...state,
                emailId: payload.email,
                firstName: payload.firstName,
                lastName: payload.lastName,
                registered: true
            }
        },
        setVerifyUserError(state, payload) {
            return {
                ...state,
                verifyUserError: payload,
            }
        },
        setUserForVerification(state, payload) {
            return {
                ...state,
                userForVerification: payload,
            }
        },
        setEmailVerificationStatus(state, payload) {
            return {
                ...state,
                emailVerificationStatus: payload,
            }
        },
        setAccountData(state, payload) {
            return {
                ...state,
                accountData: payload
            }
        },
        setAccountName(state, payload) {
            return {
                ...state,
                setAccountName: payload
            }
        },
        setAccountLogoUploadData(state, payload = {}) {
            return {
                ...state,
                accountLogoObjectCloudinary: payload
            }
        },
        loaderStatus(state, payload) {
            return {
                ...state,
                loaderBar: payload
            }
        },
        clear() {

            return initialState
        }
    },
    effects: {
        async registerAccountAsync(payload) {
            const subscriptionInfo = payload;
            //subscriptionInfo.profilePic = "http://res.cloudinary.com/aspenify/image/upload/v1535094547/uhmidgexdzniimugr7h0.jpg"
            subscriptionInfo.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            subscriptionInfo.uniqueId = uniqid.time();
            subscriptionInfo.default = false;
            try {
                let user = await registerAccountUserService.create(subscriptionInfo);
                dispatch.registerAccount.endRegistration(user);
                dispatch.registerAccount.setError('Success');
            } catch (err) {

                //toastr.error('Message', err.message);
                dispatch.registerAccount.setError(err.message);
                throw err;
            }
        },
        async generateOtp(payload){
            try {
                const user= await generateOtpService.create({userid:payload.id})
            } catch (e){
                console.error(e);
            }
        },
        
        async getUser(payload){
            try{
                const user = await checkUserService.get(payload.email);
                if(user){
                    localStorage.removeItem("userForVerification");
                    dispatch.registerAccount.setUserForVerification(user.userFound);
                    localStorage.setItem("userForVerification",user.userFound.email);
                } else {
                    dispatch.registerAccount.setVerifyUserError(true);
                }
            } catch (e){
                dispatch.registerAccount.setVerifyUserError(true);
                dispatch.registerAccount.setUserForVerification(null);
            }
        },

        async changePassword(payload) {
            let id = payload.id;
            delete payload.id;
            try {
                await resetPasswordService.patch(id, payload);
                toastr.success('Message', 'Password successfully updated.');
            } catch (err) {
                //toastr.error('Message', err.message);
                throw err;
            }

        },

        setAccountLogoImage(payload) {
            dispatch.registerAccount.setAccountLogoUploadData(payload);
        },
        setStateAccountName(payload) {
            dispatch.registerAccount.setAccountName(payload);
        },


        setloaderStatus(payload) {
            dispatch.registerAccount.loaderStatus(payload);
        },
        async verifyEmail(payload) {
            try {
                const { userid, otp } = payload;
                const result = await verifyEmailService.patch(userid, { otp });
                if (result.alreadyVerified) {
                    dispatch.registerAccount.setEmailVerificationStatus('alreadyVerified');
                } else {
                    dispatch.registerAccount.setEmailVerificationStatus('success');
                }
            } catch (err) {
                dispatch.registerAccount.setEmailVerificationStatus('error');
            }
        },
        async UpdateAccountDetails(payload) {

            try {
                await accountService.patch(payload._id, payload);
            } catch (err) {
                toastr.error('Message', err.message);
                throw err;
            }

        },

    }
}